import axios from 'axios';
import { toast } from 'react-toastify';
import React, { useState } from 'react';
import style from './Contact.module.css';
import { ValidateEmail } from '../../utils/ValidateEmail';

const Login = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [msg, setMsg] = useState('');

  const submitHandler = async (e) => {
    e.preventDefault();
    if (email) {
      if (ValidateEmail(email)) {
        await axios
          .post(
            '/user/contact',
            { email, name, msg },
            {
              headers: { 'Access-Control-Allow-Origin': '*' },
              withCredentials: true,
            }
          )
          .then((res) => {
            setEmail('');
            setName('');
            setMsg('');
            toast.success(res.data.message);
          })
          .catch((err) => {
            toast.error(err.response.data.message);
          });
      }
    } else {
      toast.error('Please fill the credentials!');
    }
  };

  return (
    <div className={style.Login}>
      <p>Contact Us</p>
      <div className={style.section}>
        <p>Name</p>
        <input
          type='text'
          value={name}
          placeholder='hunter'
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      <div className={style.section}>
        <p>Email</p>
        <input
          type='email'
          value={email}
          placeholder='hunter@hackerbro.in'
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <div className={style.section}>
        <p>Message</p>
        <input
          type='text'
          value={msg}
          placeholder='message...'
          onChange={(e) => setMsg(e.target.value)}
        />
      </div>
      <div className={style.Button} onClick={submitHandler}>
        Submit
      </div>
    </div>
  );
};
export default Login;
